import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { IconCheck, IconX, IconPlus, IconCircleMinus } from '@tabler/icons-react';
import { Group, Text, Modal, Select, Button, Divider, TextInput, ActionIcon, Stack, Checkbox } from '@mantine/core';
import TestsApi from "../../api/TestsApi";
import { notifications } from '@mantine/notifications';
import { modals } from '@mantine/modals';
import { VisiLoader, HelpTip } from "../../components/GeneralComponent/GeneralComponent";

/* Stored in place of a specific parameter value to mean "any value, as long as the
   parameter is present" - e.g. target every Google campaign instead of one campaign id.
   A sentinel rather than the literal "all" so a real campaign named "all" cannot collide.
   Matched in backend_api/include/js_test/visi_behavioral_dimensions_new.js. */
const ALL_VALUE = '__visi_all__';

export function TargetTestbyDimensions({selectedMemberWebsite, targetTestDimensionModelOpen, handleTargetDimensionCloseModal, pageid, taguchi_type_id } : any) {
	const navigate = useNavigate();

  const [dropdownSets, setDropdownSets] = useState([]);
  const [showFirstDropdown, setShowFirstDropdown] = useState(false);
  const [showSourceValueInput, setShowSourceValueInput] = useState({});
  const [showSecondDropdown, setShowSecondDropdown] = useState({});
  const [showThirdDropdown, setShowThirdDropdown] = useState({});
  const [behavioralFilterFirstDropdown, setBehavioralFilterFirstDropdown] = useState([]);
  const [behavioralFilterThirdDropdown, setBehavioralFilterThirdDropdown] = useState({});
  const [behavioralFilterSecondDropdown, setBehavioralFilterSecondDropdown] = useState({});
  const [firstDropdown, setFirstDropdown] = useState('');
  const [, setThirdDropdown] = useState('');
  const [, setSecondDropdown] = useState('');
  const [sourceValueErrors, setSourceValueErrors] = useState({});
  const [, setVisiTargetTypeFilter] = useState('');
  const [groupedSets, setGroupedSets] = useState([]);
  const [selectedBehavioralFilter, setSelectedBehavioralFilter] = useState({});
  const [activeTestId, setActiveTestId] = useState("");
  const [isVisiLoaderVisible, setIsVisiLoaderVisible] = useState(false);


  useEffect(() => {
  	if(targetTestDimensionModelOpen){
      setIsVisiLoaderVisible(true);
      TestsApi.gettargettestbydimensionsdata({
        page_id: pageid,
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
            setIsVisiLoaderVisible(false);
          }
        }
      })
      .then(data => {
        if (data.status === 1) {
          setSelectedBehavioralFilter(data.data.behavioral_filter);
          setActiveTestId(data.data.active_test_id);
          setIsVisiLoaderVisible(false);
        }else{
          setIsVisiLoaderVisible(false);
        }
      })
      .catch(error => {
        console.error("API Error:", error);
        setIsVisiLoaderVisible(false);
      });
  	}
  }, [targetTestDimensionModelOpen]);

  useEffect(() => {
    if(Object.keys(selectedBehavioralFilter).length > 0 && targetTestDimensionModelOpen){
        const dropdownValues1 = (selectedBehavioralFilter as any)?.add_group_rules?.flatMap((group, groupIndex) =>
          group.filters.map((filter, index) => ({
              id: `${groupIndex}-${index}`,
              group: groupIndex,
              typeFilterValue: filter.target_type_filter || 'is equal to',
              firstDropdown: filter.device_filter || '',
              secondDropdown: filter.traffic_source_key || '',
              thirdDropdown: filter.ad_network_type || '',
              sourceValueInput: filter.traffic_source_value || '',
          }))
      ) || [];
      setDropdownSets(dropdownValues1);

      if (dropdownValues1.length > 0) {
        setIsVisiLoaderVisible(true);
        TestsApi.behavioraldimensionsaddfilterfirstdropdown({
          type: 'TargetTestBYDimensions'
        })
        .then(response => {
          if (response.ok) {
            return response.json();
          } else {
            if (response.status === 401 || response.status === 400) {
              navigate("/logout");
              setIsVisiLoaderVisible(false);
            }
          }
        })
        .then(data => {
            if (data.status === 1) {
              setBehavioralFilterFirstDropdown(data.data.first_dropdown);
              setShowFirstDropdown(true);
              setIsVisiLoaderVisible(false);
            }else{
              setIsVisiLoaderVisible(false);
            }
        })
        .catch(error => {
          console.error("API Error:", error);
        });
      }

      let secondDropdownState = {};
      let thirdDropdownState = {};
      let sourceInputState = {};

      dropdownValues1.forEach((filter, index) => {
        const isValidFirstDropdown = ["WGxCTW9LYlErd0RIWTdrc3hvL2d3Zz09", "VDMzenM4ZGxuUDVSYTJpTDRnUUk3UT09", "SjliZHA4M1lKLzVaZUNNbGlwcXd5Zz09"].includes(filter.firstDropdown);

        if (isValidFirstDropdown) {
          setIsVisiLoaderVisible(true);
          TestsApi.behavioraldimensionsaddfilterseconddropdown({
              device_filter: filter.firstDropdown,
              page_id: pageid,
              ad_network_type: filter.thirdDropdown,
              type: 'TargetTestBYDimensions'
          })
          .then(response => {
            if (response.ok) {
              return response.json();
            } else {
              if (response.status === 401 || response.status === 400) {
                navigate("/logout");
                setIsVisiLoaderVisible(false);
              }
            }
          })
          .then(data => {
              if (data.status === 1) {
                secondDropdownState[filter.id] = true;
                setBehavioralFilterSecondDropdown(prev => ({ ...prev, [filter.id]: data.data.second_dropdown }));
                setShowSecondDropdown(prev => ({ ...prev, [filter.id]: true }));
                setIsVisiLoaderVisible(false);
              }else{
                setIsVisiLoaderVisible(false);
              }
          })
          .catch(error => {
            console.error("API Error:", error);
            setIsVisiLoaderVisible(false);
          });

          setIsVisiLoaderVisible(true);
          TestsApi.behavioraldimensionsaddfilterthirddropdown({
            device_filter: filter.firstDropdown
          })
          .then(response => {
            if (response.ok) {
              return response.json();
            } else {
              if (response.status === 401 || response.status === 400) {
                navigate("/logout");
                setIsVisiLoaderVisible(false);
              }
            }
          })
          .then(data => {
              if (data.status === 1) {
                thirdDropdownState[filter.id] = true;
                setBehavioralFilterThirdDropdown(prev => ({ ...prev, [filter.id]: data.data.third_dropdown }));
                setShowThirdDropdown(prev => ({ ...prev, [filter.id]: true }));
                setShowSecondDropdown(prev => ({ ...prev, [filter.id]: true }));
                setIsVisiLoaderVisible(false);
              }else{
                setIsVisiLoaderVisible(false);
              }
          })
          .catch(error => {
            console.error("API Error:", error);
            setIsVisiLoaderVisible(false);
          });
        }

        if (["WGxCTW9LYlErd0RIWTdrc3hvL2d3Zz09", "VDMzenM4ZGxuUDVSYTJpTDRnUUk3UT09", "SjliZHA4M1lKLzVaZUNNbGlwcXd5Zz09", "Source"].includes(filter.firstDropdown)) {
            sourceInputState[filter.id] = true;
            setShowSourceValueInput(prev => ({ ...prev, [filter.id]: true }));
        }
      });
    }
  }, [selectedBehavioralFilter]);

  const handleSaveBehavioralFilter = (e) => {
    e.preventDefault();
    let hasErrors = false;
    let errors = {};
    dropdownSets.forEach((set) => {
      if (showSourceValueInput[set.id] && (!set.sourceValueInput || set.sourceValueInput.trim() === '')) {
        errors[set.id] = true;
        hasErrors = true;
      }
    });
    if (hasErrors) {
      setSourceValueErrors(errors);
      modals.open({
        title: 'Please correct the following errors:',
        children: (
          <>
            <Text size="sm">Traffic Source Value is required!</Text>
            <Group position="right" mt="sm">
              <Button onClick={() => modals.closeAll()}>OK</Button>
            </Group>
          </>
        ),
      });
      return;
    }
    setSourceValueErrors({});

    let groupedFilters = {};
    dropdownSets.forEach((set) => {
        if (!groupedFilters[set.group]) {
            groupedFilters[set.group] = [];
        }
        groupedFilters[set.group].push({
            target_type_filter: set.typeFilterValue,
            device_filter: set.firstDropdown,
            ad_network_type: set.thirdDropdown,
            traffic_source_key: set.secondDropdown,
            traffic_source_value: set.sourceValueInput
        });
    });

    const add_group_rules = Object.keys(groupedFilters).map(groupKey => ({
        filters: groupedFilters[groupKey]
    }));
    setSelectedBehavioralFilter({ add_group_rules });

   	setIsVisiLoaderVisible(true);
    TestsApi.targetdimensionsgrouprules({
 			add_group_rules: add_group_rules,
 			active_test_id : activeTestId,
      system_website_id : selectedMemberWebsite,
      page_id : pageid,
      taguchi_test_id : taguchi_type_id,
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
          setIsVisiLoaderVisible(false);
        }
      }
    })
    .then(data => {
      if(data.status === 1){
      	setVisiTargetTypeFilter(data.data);
        setIsVisiLoaderVisible(false);
      }else{
        setIsVisiLoaderVisible(false);
      }
    })
    .catch(error => {
      console.error("API Error:", error);
      setIsVisiLoaderVisible(false);
    });
    handleBehavioralFilterCloseModal();
	};

  const handleTargetTypeFilter = (value:any,setId) => {
    setDropdownSets((prevSets) =>
      prevSets.map((set) =>
        set.id === setId ? { ...set, typeFilterValue: value || "is equal to" } : set
      )
    );
  };

  const handleFirstDropdown = (value:any,setId) => {
    setFirstDropdown(value);
    setDropdownSets((prevSets) =>
      prevSets.map((set) =>
        set.id === setId ? { ...set, firstDropdown: value } : set
      )
    );

    if(value === 'WGxCTW9LYlErd0RIWTdrc3hvL2d3Zz09' || value === 'SjliZHA4M1lKLzVaZUNNbGlwcXd5Zz09' || value === 'VDMzenM4ZGxuUDVSYTJpTDRnUUk3UT09' || value === 'VHBXdmd3MHZhSUsxN1BkREM1MCthdz09'){
    	setShowSourceValueInput(prev => ({ ...prev, [setId]: true }));
    }else{
    	setShowSourceValueInput(prev => ({ ...prev, [setId]: false }));
    }

    if(value === 'VDMzenM4ZGxuUDVSYTJpTDRnUUk3UT09'){
      setIsVisiLoaderVisible(true);
      TestsApi.behavioraldimensionsaddfilterthirddropdown({
        device_filter:value
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
            setIsVisiLoaderVisible(false);
          }
        }
      })
      .then(data => {
        if (data.status === 1) {
          const thirdDropdownData = data.data.third_dropdown;
          setBehavioralFilterThirdDropdown(prev => ({ ...prev, [setId]: thirdDropdownData }));
          setDropdownSets(prevSets => prevSets.map(set => {
            if (set.id === setId) {
              return { ...set, thirdDropdown: thirdDropdownData.length > 0 ? thirdDropdownData[0].key : null };
            }
            return set;
          }));
          setShowThirdDropdown(prev => ({ ...prev, [setId]: true }));
          setShowSecondDropdown(prev => ({ ...prev, [setId]: true }));
          setIsVisiLoaderVisible(false);
        }else{
          setIsVisiLoaderVisible(false);
        }
      })
      .catch(error => {
        console.error("API Error:", error);
        setIsVisiLoaderVisible(false);
      });
    }else{
      setShowThirdDropdown(prev => ({ ...prev, [setId]: false }));
      setShowSecondDropdown(prev => ({ ...prev, [setId]: false }));
    }
    const thirdDropdown = 'facebook';
    setIsVisiLoaderVisible(true);
    TestsApi.behavioraldimensionsaddfilterseconddropdown({
      device_filter:value,
      page_id:pageid,
      ad_network_type:thirdDropdown,
      type:'TargetTestBYDimensions'
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
          setIsVisiLoaderVisible(false);
        }
      }
    })
    .then(data => {
      if (data.status === 1) {
        const secondDropdownData = data.data.second_dropdown;
        setBehavioralFilterSecondDropdown(prev => ({ ...prev, [setId]: secondDropdownData }));

        setDropdownSets(prevSets => prevSets.map(set => {
          if (set.id === setId) {
            return { ...set, secondDropdown: secondDropdownData.length > 0 ? secondDropdownData[0].key : null };
          }
          return set;
        }));
        setShowSecondDropdown(prev => ({ ...prev, [setId]: true }));
        setIsVisiLoaderVisible(false);
      }else{
        setIsVisiLoaderVisible(false);
      }
    })
    .catch(error => {
      console.error("API Error:", error);
      setIsVisiLoaderVisible(false);
    });
  };

  const handleThirdDropdown = (value:any,setId) => {
    setThirdDropdown(value);
    setDropdownSets((prevSets) =>
      prevSets.map((set) =>
        set.id === setId ? { ...set, thirdDropdown: value } : set
      )
    );
    setIsVisiLoaderVisible(true);
    TestsApi.behavioraldimensionsaddfilterseconddropdown({
      device_filter: firstDropdown,
      page_id: pageid,
      ad_network_type:value,
      type:'TargetTestBYDimensions'
    })
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate('/logout');
          setIsVisiLoaderVisible(false);
        }
      }
    })
    .then((data) => {
      if (data.status === 1) {
        const secondDropdownData = data.data.second_dropdown;
        setBehavioralFilterSecondDropdown(prev => ({ ...prev, [setId]: secondDropdownData }));

        setDropdownSets(prevSets => prevSets.map(set => {
          if (set.id === setId) {
            return { ...set, secondDropdown: secondDropdownData.length > 0 ? secondDropdownData[0].key : null };
          }
          return set;
        }));
        setIsVisiLoaderVisible(false);
      }else{
        setIsVisiLoaderVisible(false);
      }
    })
    .catch((error) => {
      console.error('API Error:', error);
      setIsVisiLoaderVisible(false);
    });
  };

  const handleSecondDropdown = (value:any,setId) => {
    setSecondDropdown(value);
    setDropdownSets((prevSets) =>
      prevSets.map((set) =>
        set.id === setId ? { ...set, secondDropdown: value } : set
      )
    );
  };

  /* "All" targets every value of the chosen parameter (e.g. every campaign) instead
     of one specific value. Ticking it fills in the sentinel and disables the input. */
  const handleAllValueToggle = (checked:boolean, setId) => {
    setDropdownSets((prevSets) =>
      prevSets.map((set) =>
        set.id === setId ? { ...set, sourceValueInput: checked ? ALL_VALUE : '' } : set
      )
    );
    if (checked) {
      setSourceValueErrors((prev) => ({ ...prev, [setId]: false }));
    }
  };

  const handleSourceValueInput = (value:any,setId) => {
    setDropdownSets((prevSets) =>
      prevSets.map((set) =>
        set.id === setId ? { ...set, sourceValueInput: value } : set
      )
    );
  };

  const handleResetBehavioralFilter = async () => {
    TestsApi.testeditorresetfilterbehavioraldimensions({
    	active_test_id : activeTestId,
      system_website_id : selectedMemberWebsite,
      page_id : pageid,
      taguchi_test_id : taguchi_type_id,
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if(data.status === 1){
      	handleBehavioralFilterCloseModal();
        setSelectedBehavioralFilter([]);
        notifications.show({
          color: 'teal',
          icon: <IconCheck size="1.1rem" />,
          title: 'Success',
          message: data.message,
        });
      }else{
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: data.message,
        });
      }
    })
    .catch(error => {
      console.log(error);
    });
  };

  const handleBehavioralFilterCloseModal = () => {
    handleTargetDimensionCloseModal(false);
    setDropdownSets([]);
    setShowFirstDropdown(false);
    setShowSourceValueInput(false);
    setShowSecondDropdown(false);
    setShowThirdDropdown(false); 
  };

  const handleRemoveFilter = (setId) => {
    const updatedDropdownSets = dropdownSets.filter(set => set.id !== setId);
    setDropdownSets(updatedDropdownSets);
  };

  const handleAddRuleGroup = () => {
    const newGroupIndex = Math.max(...dropdownSets.map(set => set.group), 0) + 1;
    const newId = dropdownSets.length > 0 ? dropdownSets[dropdownSets.length - 1].id + 1 : 0;
    const newSet = { id: newId, typeFilterValue: 'is equal to', firstDropdown: '', secondDropdown: '', thirdDropdown: '', group: newGroupIndex };

    setDropdownSets(prevSets => [...prevSets, newSet]);

    setShowSecondDropdown(prev => ({ ...prev, [newId]: false }));
    setShowThirdDropdown(prev => ({ ...prev, [newId]: false }));

    setIsVisiLoaderVisible(true);
    TestsApi.behavioraldimensionsaddfilterfirstdropdown({
    	type: 'TargetTestBYDimensions'
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
          setIsVisiLoaderVisible(false);
        }
      }
    })
    .then(data => {
      if (data.status === 1) {
        const firstDropdownData = data.data.first_dropdown;
        setBehavioralFilterFirstDropdown(firstDropdownData);
        setDropdownSets(prevSets => prevSets.map(set => {
          if (set.id === newId) {
            return { ...set, firstDropdown: firstDropdownData.length > 0 ? firstDropdownData[0].key : null };
          }
          return set;
        }));
        setShowFirstDropdown(true);
        setIsVisiLoaderVisible(false);
      }
    })
    .catch(error => {
      console.error("API Error:", error);
      setIsVisiLoaderVisible(false);
    });
	};

	const handleAddFilter = (groupIndex) => {
    const newId = dropdownSets.length > 0 ? dropdownSets[dropdownSets.length - 1].id + 1 : 0;
    const newSet = { id: newId, typeFilterValue: 'is equal to', firstDropdown: '', secondDropdown: '', thirdDropdown: '', group: groupIndex };

    setDropdownSets(prevSets => [...prevSets, newSet]);

    setShowSecondDropdown(prev => ({ ...prev, [newId]: false }));
    setShowThirdDropdown(prev => ({ ...prev, [newId]: false }));

    setIsVisiLoaderVisible(true);
    TestsApi.behavioraldimensionsaddfilterfirstdropdown({
        type: 'TargetTestBYDimensions'
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
          setIsVisiLoaderVisible(false);
        }
      }
    })
    .then(data => {
      if (data.status === 1) {
        const firstDropdownData = data.data.first_dropdown;
        setBehavioralFilterFirstDropdown(firstDropdownData);
        setDropdownSets(prevSets => prevSets.map(set => {
          if (set.id === newId) {
            return { ...set, firstDropdown: firstDropdownData.length > 0 ? firstDropdownData[0].key : null };
          }
          return set;
        }));
        setShowFirstDropdown(true);
        setIsVisiLoaderVisible(false);
      }
    })
    .catch(error => {
      console.error("API Error:", error);
      setIsVisiLoaderVisible(false);
    });
	};

	useEffect(() => {
		const groupedDropdownSets = Object.values(
		  dropdownSets.reduce((acc, set) => {
		    if (!acc[set.group]) acc[set.group] = [];
		    acc[set.group].push(set);
		    return acc;
		  }, {} as Record<string, typeof dropdownSets>)
		);
		setGroupedSets(groupedDropdownSets);
	}, [dropdownSets]);

  return (
    <>

    	<Modal.Root opened={targetTestDimensionModelOpen} onClose={handleBehavioralFilterCloseModal} size="90%" trapFocus={false}>
		    <Modal.Overlay />
		    <Modal.Content>
          <VisiLoader VisiLoaderVisible={isVisiLoaderVisible} />
		      <Modal.Header>
		        <Modal.Title>TARGET TEST BY DIMENSIONS <HelpTip helpId={294} /></Modal.Title>
		        <Modal.CloseButton />
		      </Modal.Header>
		      <Modal.Body>
				    {dropdownSets.length > 0 && (
				      <Stack spacing={2}>
				        <Text weight={500} ml={10}>Rules</Text>
				        <Text weight={500} ml={10}>Show this test if</Text>
				      </Stack>
				    )}
		      	<Group>
		          {dropdownSets.length > 0 && groupedSets.map((group, index) => (
		            <Stack key={index} spacing={2} style={{width:"100%"}}>
						    {index > 0 && <Text weight={500} ml={10} style={{ marginBottom: 5 }}>Or</Text>}
						    <Stack spacing={2} ml={20}>
						    {group && group.map((set, setIndex) => (
						      <Group align="center" style={{ marginBottom: 10 }} key={set.id}>
		            	{showFirstDropdown && (
				            <Select
									    data={[
									      { value: 'is equal to', label: 'is equal to' },
									      { value: 'is not equal to', label: 'is not equal to' },
									    ]}
									    name="target_type_filter[]"
									    value={set.typeFilterValue || "is equal to"}
			                onChange={(value) => handleTargetTypeFilter(value, set.id)}
									    size="sm"
									    withinPortal
									    searchable
									  />
								  )}
								  {showFirstDropdown && (
			              <Select
			                data={behavioralFilterFirstDropdown.map((item) => ({ value: item.key, label: item.value }))}
			                value={set.firstDropdown}
			                onChange={(value) => handleFirstDropdown(value, set.id)}
			                searchable
			                placeholder="Select value"
			                nothingFound="No options"
			                size="sm"
			                dropdownPosition="bottom"
			                withinPortal
			              />
		              )}
		              {showThirdDropdown[set.id] && (
			              <Select
			                data={(behavioralFilterThirdDropdown[set.id] || []).map((item) => ({ value: item.key, label: item.value }))}
			                value={set.thirdDropdown}
			                onChange={(value) => handleThirdDropdown(value, set.id)}
			                searchable
			                nothingFound="No options"
			                size="sm"
			                dropdownPosition="bottom"
			                withinPortal
			              />
		              )}
		              {showSecondDropdown[set.id] && (
			              <Select
			                data={(behavioralFilterSecondDropdown[set.id] || []).map((item) => ({ value: item.key, label: item.value }))}
			                value={set.secondDropdown}
			                onChange={(value) => handleSecondDropdown(value, set.id)}
			                searchable
			                nothingFound="No options"
			                size="sm"
			                dropdownPosition="bottom"
			                withinPortal
			              />
		              )}
		              {showSourceValueInput[set.id] && (
		              	<Group spacing={8} align="center" noWrap>
		              		<TextInput
		              			placeholder={set.sourceValueInput === ALL_VALUE ? "All values" : "Source Value (eg. newsletter)"}
		              			style={{ width: "210px", border: sourceValueErrors[set.id] ? "1px solid red" : "1px solid #ced4da", borderRadius: "4px" }}
		              			disabled={set.sourceValueInput === ALL_VALUE}
		              			value={set.sourceValueInput === ALL_VALUE ? '' : set.sourceValueInput}
		              			onChange={(value) => handleSourceValueInput(value.target.value, set.id)}
		              		/>
		              		<Checkbox
		              			label="All"
		              			checked={set.sourceValueInput === ALL_VALUE}
		              			onChange={(event) => handleAllValueToggle(event.currentTarget.checked, set.id)}
		              		/>
		              	</Group>
		              )}
		              {showFirstDropdown && (
		              	<>
		              	<div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
		              	<Button color="teal" onClick={() => handleAddFilter(set.group)} size="sm">
										  <IconPlus size="1.1rem" color="white"/><Text ml={2}>and</Text>
										</Button>
		              	<ActionIcon title="Remove">
			            		<IconCircleMinus size="1.1rem" color="red" onClick={() => handleRemoveFilter(set.id)}/>
			            	</ActionIcon>
			            	</div>
			            	</>
		              )}
		            </Group>
		          ))}
		          </Stack>
		          </Stack>
					  ))}
		        </Group>
		        <Button mt={20} onClick={handleAddRuleGroup}>
		          <IconPlus size="1.1rem" color="white"/><Text ml={5}>{dropdownSets.length === 0 ? "Add Filter" : "Add Rule Group"}</Text>
		        </Button>
		        <Divider my="sm" />  
		        <Group position="right">
		        	<Button type="button" size="sm" color="orange" onClick={handleResetBehavioralFilter}>
		        	  Reset Filter
		        	</Button>
		          <Button onClick={handleSaveBehavioralFilter} size="sm" w={80}>
		            Save
		          </Button>
		        </Group>
		      </Modal.Body>
		    </Modal.Content>
		  </Modal.Root>
    </>
  );
}